import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useSelector } from 'react-redux';

export const minMaxValue = (data: any, min: any, max: any) => {
  let minOld = min
  let maxOld = max
  if (data && data.length > 0) {
    data.map((item: any) => {
      if (item?.y && minOld > item?.y) {
        minOld = item?.y
      }

      if (item?.y && maxOld < item?.y) {
        maxOld = item?.y
      }
    })
  }

  return { min: minOld, max: maxOld }
}

export default function ChartColumn(props: any) {
  const options = props?.options
  const CommnonStore = useSelector((state: any) => state?.CommnonStore)

  let widthColumn = 11;
  if (CommnonStore?.innerWidthScreen > 1500) {
    widthColumn = 15
  }

  return (
    <>
      <div className='DPmMCYSeAT'>
        <div className='fgtutbvxfh'>
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
          />
        </div>
      </div>
    </>
  )
}